import gql from 'graphql-tag';

export const GET_CREDIT_SUBMISSIONS_SELECT_OPTIONS = gql`
  query CreditSubmissionsSelectOptions($id: ID!) {
    creditSubmissionsSelectOptions: creditSubmissionsByDynamicsVOId(id: $id) {
      decision
      lenderName
      creditSubStage
      createdDateTime
      value: creditSubmissionId
      dynamicCSId: creditSubId
    }
  }
`;
